import { twMerge } from 'tailwind-merge'
import { ISection } from '../../models/ISection'
import Post from '../components/Post'
import Link from 'next/link';
import SectionTitle from '../components/SectionTitle';

export default function SectionSix(data: ISection) {
  if (!data?.posts?.length) return null;
  const restPosts = data.posts.slice(1);
  const post1 = data.posts[0];
  const post2 = data.posts[1];
  const post3 = data.posts[2];
  const post4 = data.posts[3];
  return (
      <section key={data.internalName} className='bg-gray-0 section-full py-[48px] dark:bg-quinary'>
      {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} target='_self' classNames={{wrapper: 'py-0 bg-transparent', text: 'dark:text-white'}}/> : null}

    <div className='hidden desktop:flex items-start gap-[24px] desktop:px-[6px]'>
         <Post 
         badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
         newsType={post1.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post1.type} 
            title={post1.title}
            image={{
              src: post1.image, 
              fill: true, 
              sizes: '100vw', 
              className: twMerge(
                'rounded-[12px]', 
              ), 
              alt: post1.imageAlt || '', 
              ...(data.eager ? {priority: true, loading: 'eager'} : {})
            }} 
            category={post1.category} 
            uniqueCode={post1.uniqueCode}
            hide={{category: true}}
            classNames={{
              contentContainer: twMerge('p-[16px] flex-1 desktop:justify-center'), 
              image: twMerge('mb-0 h-[481.5px]'), 
              title: twMerge('line-clamp-2 h3'), 
              wrapper: twMerge('w-[70%] desktopSm:w-[60%] rounded-[12px]')
            }}
            thumbnail={post1.thumbnail}
            />
            <div className='flex flex-col w-[30%] desktopSm:w-[40%] gap-[24px] h-[481.5px]'>
        {restPosts.map((p,i) => {
          return (
            <Post 
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={p.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={p.type} 
            title={p.title}
            image={{
              src: p.image, 
              fill: true, 
              sizes: '100vw', 
              className: twMerge('rounded-[12px] aspect-[4/3]'), 
              alt: p.imageAlt || '', 
              ...(data.eager ? {priority: true, loading: 'eager'} : {})
            }} 
            category={p.category} 
            uniqueCode={p.uniqueCode}
            hide={{category: true}}
            classNames={{
              contentContainer: twMerge('p-[16px] pl-0 flex-1 desktop:justify-center'), 
              image: twMerge('mb-0 w-[195px]'), 
              title: twMerge('line-clamp-4 h5'), 
              wrapper: twMerge('flex-row h-[144.5px] rounded-[12px]')
            }}
            thumbnail={p.thumbnail}
            />
          )})}
          </div>
       </div>




       <div className='grid grid-cols-1 tablet:grid-cols-3 tablet:grid-rows-[1fr_auto] desktop:hidden gap-[24px]'>
         <Post 
         isLarge
         badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
         newsType={post1.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post1.type} 
            title={post1.title}
            image={{
              src: post1.image, 
              fill: true, 
              sizes: '100vw', 
              className: twMerge('rounded-[12px]'), 
              alt: post1.imageAlt || '', 
              ...(data.eager ? {priority: true, loading: 'eager'} : {})
            }} 
            category={post1.category} 
            uniqueCode={post1.uniqueCode}
            hide={{category: true}}
            classNames={{
              contentContainer: twMerge('p-[16px]'), 
              title: twMerge('line-clamp-4 tablet:h3'), 
              wrapper: twMerge('flex-1 rounded-[12px] tablet:col-span-full tablet:row-start-1 tablet:row-end-2')
            }}
            thumbnail={post1.thumbnail}
          />
           <Post 
           badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
           newsType={post2.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post2.type} 
            title={post2.title}
            image={{
              src: post2.image, 
              fill: true, 
              sizes: '100vw', 
              className: twMerge('rounded-[12px]'), 
              alt: post2.imageAlt || '', 
            }} 
            category={post2.category} 
            uniqueCode={post2.uniqueCode}
            hide={{category: true}}
            classNames={{
              contentContainer: twMerge('p-[16px] pl-0 tablet:pl-[16px]'), 
              image: twMerge('mb-0 aspect-[4/3] w-[50%] tablet:w-full'), 
              title: twMerge('line-clamp-4 h5'), 
              wrapper: twMerge('flex-1 rounded-[12px] flex-row tablet:flex-col tablet:col-span-1 tablet:row-start-2 tablet:row-end-2')
            }}
            thumbnail={post2.thumbnail}
          />

           <Post 
           badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
           newsType={post3.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post3.type} 
            title={post3.title}
            image={{
              src: post3.image, 
              fill: true, 
              sizes: '100vw', 
              className: twMerge('rounded-[12px]'), 
              alt: post3.imageAlt || '', 
            }} 
            category={post3.category} 
            uniqueCode={post3.uniqueCode}
            hide={{category: true}}
            classNames={{
              contentContainer: twMerge('p-[16px] pl-0 tablet:pl-[16px]'), 
              image: twMerge('mb-0 aspect-[4/3] w-[50%] tablet:w-full'), 
              title: twMerge('line-clamp-4 h5'), 
              wrapper: twMerge('flex-1 rounded-[12px] flex-row tablet:flex-col tablet:col-span-1 tablet:row-start-2 tablet:row-end-2')
            }}
            thumbnail={post3.thumbnail}
          />

           <Post 
              badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
           newsType={post4.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post4.type} 
            title={post4.title}
            image={{
              src: post4.image, 
              fill: true, 
              sizes: '100vw', 
              className: twMerge('rounded-[12px]'), 
              alt: post4.imageAlt || '', 
            }} 
            category={post4.category} 
            uniqueCode={post4.uniqueCode}
            hide={{category: true}}
            classNames={{
              contentContainer: twMerge('p-[16px] pl-0 tablet:pl-[16px]'), 
              image: twMerge('mb-0 aspect-[4/3] w-[50%] tablet:w-full'), 
              title: twMerge('line-clamp-4 h5'), 
              wrapper: twMerge('flex-1 rounded-[12px] flex-row tablet:flex-col tablet:col-span-1 tablet:row-start-2 tablet:row-end-2')
            }}
            thumbnail={post4.thumbnail}
          />
       </div>

          <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>
      </section>
  )
}